import React from 'react';

import {
  TradeInCalculator,
  OfficesMap,
  VoteForm,
  SubscribeForm,
  threeFours,
  TradeInNewCalculator,
} from 'widgets';
import connectProvider from 'utils/redux-provider';
import rootReducer from 'store/SharedZone/reducers';

import { convertLegacyModel } from './dataConverter';
import SharedZone from './SharedZone';

const SharedZonePage = () => <SharedZone />;

export default connectProvider(rootReducer, convertLegacyModel, {
  TradeInCalculator,
  TradeInNewCalculator,
  OfficesMap,
  SubscribeForm,
  VoteForm,
  threeFours,
})(SharedZonePage);
